import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, NotebookPen, Calculator, Ruler, Dumbbell, Trophy } from 'lucide-react';
import FoodDiaryTab from '../components/portal/FoodDiaryTab';
import MacroDayTypeTab from '../components/portal/MacroDayTypeTab';
import BodyFatTab from '../components/portal/BodyFatTab';
import OneRmTab from '../components/portal/OneRmTab';
import ContestPrepTab from '../components/portal/ContestPrepTab';

const PRO_KEY = 'oc_pro_mode_v1';

const TABS = [
  { v: 'naplo', t: 'Étkezési napló', icon: NotebookPen, pro: false },
  { v: 'makro', t: 'Makró & naptípus', icon: Calculator, pro: false },
  { v: 'testzsir', t: 'Testzsír / kaliper', icon: Ruler, pro: false },
  { v: 'ero', t: 'Erő / 1RM', icon: Dumbbell, pro: false },
  { v: 'verseny', t: 'Verseny-felkészülés', icon: Trophy, pro: true },
];

export default function PortalToolsPage() {
  const [tab, setTab] = useState('naplo');
  const [pro, setPro] = useState(localStorage.getItem(PRO_KEY) === '1');

  useEffect(() => { localStorage.setItem(PRO_KEY, pro ? '1' : '0'); }, [pro]);
  useEffect(() => { if (!pro && tab === 'verseny') setTab('naplo'); }, [pro, tab]);

  const visible = TABS.filter(t => !t.pro || pro);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-20">
        <div className="container mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between gap-3">
            <Link to="/fiokom" data-testid="tools-back"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-gray-500 hover:text-gray-900">
              <ChevronLeft size={17} /> Vissza a fiókomba
            </Link>
            <label className="flex items-center gap-2 cursor-pointer select-none">
              <span className="text-[11px] font-bold uppercase tracking-wider text-gray-500">Versenyző mód</span>
              <button
                type="button"
                data-testid="pro-mode-toggle"
                onClick={() => setPro(p => !p)}
                className={`relative w-11 h-6 rounded-full transition-colors ${pro ? 'bg-yellow-500' : 'bg-gray-300'}`}
              >
                <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${pro ? 'translate-x-5' : ''}`} />
              </button>
            </label>
          </div>

          <h1 className="text-xl sm:text-2xl font-black text-gray-900 mt-3"
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Napló &amp; kalkulátorok
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">
            Naplózd az étkezéseid, és kövesd a számaid — kezdőként és versenyzőként is.
          </p>

          <nav className="flex gap-1 mt-4 overflow-x-auto -mx-1 px-1 pb-1">
            {visible.map(({ v, t, icon: Icon }) => (
              <button
                key={v}
                data-testid={`tools-tab-${v}`}
                onClick={() => setTab(v)}
                className={`shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-bold transition-colors ${
                  tab === v ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon size={15} /> {t}
              </button>
            ))}
          </nav>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 py-6 max-w-5xl">
        {tab === 'naplo' && <FoodDiaryTab />}
        {tab === 'makro' && <MacroDayTypeTab />}
        {tab === 'testzsir' && <BodyFatTab />}
        {tab === 'ero' && <OneRmTab />}
        {tab === 'verseny' && pro && <ContestPrepTab />}

        {!pro && (
          <p className="text-xs text-gray-500 mt-8 text-center">
            Versenyre készülsz? Kapcsold be a <strong>Versenyző módot</strong> a felül, és megjelennek
            a verseny-felkészülési eszközök is.
          </p>
        )}
      </main>
    </div>
  );
}
